import { useState } from 'react';

const TESTIMONIALS = [
  {
    quote: 'IWC Roofing replaced our entire roof in just two days. Fast, professional, and the quality is outstanding. The crew was respectful, cleaned everything up, and the roof looks incredible. Our neighbors all asked who we used.',
    name: 'Robert M.',
    location: 'Salt Lake City, UT',
    service: 'Full Roof Replacement',
    rating: 5,
  },
  {
    quote: 'After the hailstorm, we were overwhelmed with the insurance process. IWC stepped in and handled absolutely everything — maximized our claim and the new roof looks incredible. Could not have asked for a better experience.',
    name: 'Sarah T.',
    location: 'Sandy, UT',
    service: 'Storm Damage + Insurance Claim',
    rating: 5,
  },
  {
    quote: 'Best roofing company we have ever worked with. Transparent pricing, zero surprises, and they cleaned up perfectly every single day. The finished roof is beautiful and the workmanship speaks for itself.',
    name: 'Dave & Linda K.',
    location: 'Draper, UT',
    service: 'Roof Replacement',
    rating: 5,
  },
  {
    quote: 'Called IWC on a Monday about a roof leak and they had someone out the same day. The repair was done quickly and at a completely fair price. I highly recommend IWC for any roofing needs in Utah.',
    name: 'Angela P.',
    location: 'West Jordan, UT',
    service: 'Roof Repair',
    rating: 5,
  },
  {
    quote: 'IWC handled our 40-unit apartment complex re-roofing project on time and under budget. Their commercial team is top-notch and communicates throughout the whole process. We will absolutely use them again.',
    name: 'Mark J.',
    location: 'Ogden, UT',
    service: 'Commercial Roofing',
    rating: 5,
  },
  {
    quote: 'I was nervous about the whole process but IWC made it completely stress-free. They walked me through every step, explained everything clearly, and delivered a roof that looks stunning against our Utah mountain backdrop.',
    name: 'Patricia L.',
    location: 'South Jordan, UT',
    service: 'Roof Replacement',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const [startIdx, setStartIdx] = useState(0);
  const visible = 3;
  const total = TESTIMONIALS.length;

  const prev = () => setStartIdx((i) => (i === 0 ? total - visible : i - 1));
  const next = () => setStartIdx((i) => (i >= total - visible ? 0 : i + 1));

  const shown = [
    TESTIMONIALS[startIdx % total],
    TESTIMONIALS[(startIdx + 1) % total],
    TESTIMONIALS[(startIdx + 2) % total],
  ];

  return (
    <section id="testimonials" className="py-28 bg-surface">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="inline-block w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
            <h2 className="font-heading font-900 text-charcoal text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-none">
              What Customers<br />
              <span className="text-brand-orange">Are Saying</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white border border-surface-dark hover:border-brand-orange hover:text-brand-orange text-charcoal transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              onClick={next}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-orange text-white hover:bg-brand-orange-dark transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {shown.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 flex flex-col">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-brand-orange text-lg"></i>
                ))}
              </div>
              {/* Quote */}
              <blockquote className="font-body text-charcoal/80 text-base leading-relaxed flex-1 mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              {/* Customer */}
              <div className="flex items-center gap-4 pt-5 border-t border-surface-dark">
                <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/10 rounded-full flex-shrink-0">
                  <i className="ri-user-3-fill text-brand-orange text-xl"></i>
                </div>
                <div>
                  <p className="font-heading font-800 text-charcoal text-sm uppercase tracking-wide">{t.name}</p>
                  <p className="font-body text-charcoal/50 text-xs">{t.location}</p>
                  <p className="font-body text-brand-orange text-xs font-600 mt-0.5">{t.service}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-10">
          {Array.from({ length: total - visible + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setStartIdx(i)}
              className={`rounded-full transition-all duration-200 cursor-pointer ${
                i === startIdx ? 'w-8 h-3 bg-brand-orange' : 'w-3 h-3 bg-charcoal/20 hover:bg-charcoal/40'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
